export const ADD_TO_CART = 'ADD_TO_CART';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_SAVE_SHIPPING = 'CART_SAVE_SHIPPING';
export const CART_REMOVE_ITEM_ALL = 'CART_REMOVE_ITEM_ALL';
